import { render, staticRenderFns } from "./VolunteerAgencyCard.vue?vue&type=template&id=e685a4e0&scoped=true"
import script from "./VolunteerAgencyCard.vue?vue&type=script&lang=js"
export * from "./VolunteerAgencyCard.vue?vue&type=script&lang=js"
import style0 from "./VolunteerAgencyCard.vue?vue&type=style&index=0&id=e685a4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e685a4e0",
  null
  
)

export default component.exports